module.exports = __webpack_public_path__ + "img/lotteryOpening.96641dd6.png";